import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { SiteAccessGate } from './components/SiteAccessGate.tsx'
import { installSiteAuthFetchInterceptor } from './services/siteAuth.ts'

installSiteAuthFetchInterceptor()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SiteAccessGate>
      <App />
    </SiteAccessGate>
  </StrictMode>,
)
